import { render, staticRenderFns } from "./VaccineTemplate.vue?vue&type=template&id=ad3f336c&scoped=true"
import script from "./VaccineTemplate.vue?vue&type=script&lang=js"
export * from "./VaccineTemplate.vue?vue&type=script&lang=js"
import style0 from "./VaccineTemplate.vue?vue&type=style&index=0&id=ad3f336c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3f336c",
  null
  
)

export default component.exports